export default function setPriceRange(priceRange) {
	this._updateSearchResults({
		priceRange,
	})
}
